import { ERR_NETWORK, REDIRECT_NOT_ALLOWED_URL, REDIRECT_TO_LOGIN_URL } from 'appConstants';

const handleError = (error: any) => {
  const status = error?.response?.status;

  if (status === 401 && process.env.REACT_APP_IS_AUTH_ENABLED === 'true') {
    error.message = 'User Not authenticated';
    error.authError = true;
    window.onbeforeunload = null;

    if (window.location.pathname !== REDIRECT_TO_LOGIN_URL)
      window.location.href = REDIRECT_TO_LOGIN_URL;
    return Promise.reject(error);
  }

  if (status === 403) {
    error.message = 'User Not Allowed';
    error.authError = true;
    if (window.location.pathname !== REDIRECT_NOT_ALLOWED_URL)
      window.location.href = REDIRECT_NOT_ALLOWED_URL;
    return Promise.reject(error);
  }

  if (error.code === ERR_NETWORK) {
    const errorResp = {
      status: '',
      message: error.message,
      caption: '',
      severity: '',
      errorCode: error.code,
    };
    return Promise.reject(errorResp);
  }

  if (Array.isArray(error.response.data)) {
    const firstError = error.response.data[0];
    const errorMessage = firstError.description;

    const errorResp = {
      status,
      message: errorMessage,
      caption: firstError.caption ? firstError.caption : '',
      severity: firstError.severity ? firstError.severity : '',
      errorCode: firstError.errorCode,
    };

    return Promise.reject(errorResp);
  }

  return Promise.reject(error);
};

export default handleError;
